define ['./help.scss'], () ->
  ($scope, show_buttons, Landlord) ->
    $scope.show_buttons = show_buttons
    $scope.toggle_1 = $scope.toggle_2 = $scope.toggle_3 =true
    
    Landlord.getMe().$promise.then (me) ->
      if me.my_payments_fee || me.my_payments_fee == 0
        $scope.my_payments_fee = me.my_payments_fee
      else
        $scope.my_payments_fee = 34.95



// WEBPACK FOOTER //
// ./components/dashboard/payments/help/help.coffee